import React from "react";
import { Formik, Form, Field, useFormikContext } from "formik";
import * as Yup from "yup";
import { MdClose, MdCheck } from "react-icons/md";

import FieldError from "../../../shared/FieldError";

const BloodPressure = ({ data, handleField }) => {
  const BloodPressure = Yup.object().shape({
    data: Yup.string()
      .nullable()
      .matches(/^\d{1,3}\/\d{1,3}$/, "Blood Pressure Value must be in format ​systolic/diastolic."),
  });
  return (
    <div>
      <Formik
        initialValues={{
          data: data.value,
        }}
        validationSchema={BloodPressure}
        validateOnChange={true}
        onSubmit={async (values) => {
          console.log(values);
          const request = await handleField({
            id: data.id,
            value: values.data,
            cpr_id: data.cprId,
            quality_measurement_type_id: data.quality_measurement_type_id,
          });

          console.log(request);
        }}
      >
        {({ values, errors, setFieldValue, initialValues, isSubmitting }) => {
          return (
            <Form>
              <label>Blood Pressure</label>
              <input
                className="default"
                placeholder="e.g. 120/80"
                value={values.data}
                onChange={(e) => setFieldValue("data", e.target.value)}
              />
              {initialValues.data !== values.data && !errors.data && (
                <div className="check-cancel-buttons flex">
                  <button className="check small" type="submit">
                    <MdCheck className="check-icon" />
                  </button>
                  <button
                    className="cancel small"
                    disabled={isSubmitting}
                    onClick={() => {
                      initialValues.data
                        ? setFieldValue("data", initialValues.data)
                        : setFieldValue("data", "");
                    }}
                  >
                    <MdClose className="cancel-icon" />
                  </button>
                </div>
              )}
              {errors.data ? <FieldError error={errors.data} /> : null}
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default BloodPressure;
